<template>
  <div>
    <Head title="Create Profile" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/export-profiles">Profiles</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-5xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full" label="Title" />
          <select-input v-model="form.connector_id" :error="form.errors.connector_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Connector" @change="onChange($event)">
            <option :value="null" />
            <option v-for="connector in connectors" :key="connector.id" :value="connector.id">{{ connector.title }}</option>
          </select-input>
          <text-input v-model="form.scheduled_task" :error="form.errors.scheduled_task" class="pb-8 pr-6 w-full lg:w-1/2" label="Schedule" />
          <div v-if="connectorFields != null" class="pb-8 pr-6 w-full">
            <lable class="form-label">Fields :</lable>
            <ul class="flex flex-wrap form-input w-full">
              <span v-if="!connectorFields.length"> Fields not found. </span>
              <li class="mt-1 mb-1 lg:w-1/2 pl-8" v-for="connectorField in connectorFields" :key="connectorField"><input type="checkbox" :value="connectorField" v-bind:id="connectorField" v-model="form.fields" /> {{ connectorField }}</li>
            </ul>
          </div>
          <div v-if="connectorFields == null" class="pb-8 pr-6 w-full">
            <lable class="form-label">Fields :</lable>
            <span class="form-input"> Please select Connector </span>
          </div>
          <div v-if="modifiersByConnector != ''" class="pb-8 pr-6 w-full lg:w-1/2">
            <lable class="form-label">Modifiers :</lable>
            <ul class="w-full form-input">
              <li class="mt-1 mb-1 pl-8" v-for="modifier in modifiersByConnector" :key="modifier.id"><input type="checkbox" :value="modifier.id" v-bind:id="modifier.id" v-model="form.modifier" /> {{ modifier.title }}</li>
            </ul>
          </div>
          <div v-if="modifiersByConnector == ''" class="pb-8 pr-6 w-full lg:w-1/2">
            <lable class="form-label">Modifiers :</lable>
            <span class="form-input"> Modifier not found. </span>
          </div>
          <div v-if="filtersByConnector != ''" class="pb-8 pr-6 w-full lg:w-1/2">
            <lable class="form-label">Filters :</lable>
            <ul class="form-input w-full">
              <li class="mt-1 mb-1 pl-8" v-for="filter in filtersByConnector" :key="filter.id"><input type="checkbox" :value="filter.id" v-bind:id="filter.id" v-model="form.filters" /> {{ filter.title }}</li>
            </ul>
          </div>
          <div v-if="filtersByConnector == ''" class="pb-8 pr-6 w-full lg:w-1/2">
            <lable class="form-label">Filters :</lable>
            <span class="form-input"> Filter not found. </span>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Profile</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    connectors: Array,
    filters: Array,
    modifiers: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        title: '',
        connector_id: '',
        fields: [],
        scheduled_task: '',
        modifier: [],
        filters: [],
      }),
      connectorFields: null,
      modifiersByConnector: [],
      filtersByConnector: [],
    }
  },
  methods: {
    store() {
      this.form.post('/export-profiles')
    },
    onChange(event) {
      let connectorId = event.target.value
      this.connectorFields = null
      this.modifiersByConnector = []
      this.filtersByConnector = []
      this.connectors.forEach((value, index) => {
        if (value.id == connectorId) {
          let json = value.mapping_json
          this.connectorFields = Object.keys(JSON.parse(json))
          this.modifiers.forEach((value, index) => {
            if (value.connector_id == connectorId) {
              this.modifiersByConnector.push(value)
            }
          })
          this.filters.forEach((value, index) => {
            if (value.connector_id == connectorId) {
              this.filtersByConnector.push(value)
            }
          })
        }
      })
    },
  },
}
</script>
